/**
 * Copyright © 2026 Adnuntius AS.
 */
import {firstValueFrom, Subject} from 'rxjs';
import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {resourceOptionParams} from '../common/controller/signal-admin-resource-api';
import * as _ from 'lodash';
import {BsModalRef} from 'ngx-bootstrap/modal';
import template from './report-schedule-recipients-modal.component.html';
import {UserApiService} from '../admin/user/user-api.service';
import {deferMarkForCheck} from '../common/util/defer-mark-for-check';
import {ReportScheduleApiService} from './report-schedule-api.service';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {AppSharedModule} from '../common/app-shared.module';

export interface ReportScheduleRecipientsModalResult {
  recipientUsers: any[];
  success?: boolean;
  validationWarnings?: any;
}

@Component({
  standalone: true,
  imports: [AppSharedModule, FormsModule, TranslateModule],
  selector: 'adn-report-schedule-recipients-modal',
  template
})
export class ReportScheduleRecipientsModalComponent implements OnInit {
  recipientUsers: any[] = [];
  isNew = false;
  scheduleModel: any;
  salespersonId?: string;
  adOpsId?: string;

  readonly onClosed = new Subject<ReportScheduleRecipientsModalResult | void>();

  allUsers: any[] | null = null;
  selUsers: string[] = [];

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(UserApiService) private readonly User: UserApiService,
    private readonly cdr: ChangeDetectorRef,
    private readonly api: ReportScheduleApiService,
  ) {
  }

  ngOnInit(): void {
    this.selUsers = _.map(this.recipientUsers || [], 'id');
    firstValueFrom(this.User.listOptions(resourceOptionParams({minimal: true}))).then((page: any) => {
      deferMarkForCheck(this.cdr, () => {
        this.allUsers = page.results || [];
      });
    });
  }

  isSelected(userId: string): boolean {
    return this.selUsers.includes(userId);
  }

  toggleUser(userId: string): void {
    const idx = this.selUsers.indexOf(userId);
    if (idx >= 0) {
      this.selUsers.splice(idx, 1);
    } else {
      this.selUsers.push(userId);
    }
  }

  save(): void {
    const recipientUsers = _.filter(_.map(this.selUsers, (userId) => {
      return _.find(this.allUsers, ['id', userId]);
    }), (user) => {
      return user && !!user.id;
    });

    if (!this.isNew && this.scheduleModel?.id) {
      this.api.saveRecipients(this.scheduleModel.id, recipientUsers).subscribe({
        next: (savedSchedule: any) => {
        deferMarkForCheck(this.cdr, () => {
          this.onClosed.next({
            recipientUsers,
            success: true,
            validationWarnings: savedSchedule?.validationWarnings
          });
          this.bsModalRef.hide();
        });
        },
        error: () => {
        deferMarkForCheck(this.cdr, () => {
          this.onClosed.next({recipientUsers, success: false});
          this.bsModalRef.hide();
        });
        }
      });
      return;
    }

    deferMarkForCheck(this.cdr, () => {
      this.onClosed.next({recipientUsers});
      this.bsModalRef.hide();
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
